export default __webpack_public_path__ + "static/introAuberge700k-6a17493a564be348e681a77d6a93aa9d.mp4";